var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/58b5061388252bc75bcaa01b11dbd2e9.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6ed1627c0e91fc2817ff6296d2512535.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fad4f5d8afad25764fe3e0406f204d76.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    